<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
 
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t('AddNew') : $t('Update') }} {{$t('Item')}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">

        <!-- NAME -->
        <vs-input :label="$t('Name')" :disabled="true" v-model="Name" class="mt-5 w-full" name="name" v-validate="'required'" />
            <vs-input :label="$t('Description')"  v-model="Description" class="mt-5 w-full" name="Description" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>   
         <br/>
         <div class="vx-row" style="padding-left:20px">
          <label> {{$t('IsRegistration')}}</label>
        <vs-checkbox  :disabled="true" v-model="IsRegistration" @change="getNextStatus"></vs-checkbox>
         </div>
        
             <vs-select class="mt-5 w-full" :label="$t('ParentStatus')"  :disabled="true" v-model="ParentStatusID" >
                        <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in nextStatus" />
              </vs-select>
           
            <span class="text-danger text-sm"  v-show="errors.has('ParentStatus')">{{ errors.first('ParentStatus') }}</span>   
                
                  <p class="mt-5 ">{{$t('MailTemplate')}}</p>
          <v-select
            label="Subject"
            v-model="MailTemplateID"
            :options="MailTemplates" 
            class="w-full"
            :reduce="value => value.ID"
            @input="getMailData"
          />
          
            <span class="text-danger text-sm" v-show="errors.has('MailTemplate')">{{ errors.first('MailTemplate') }}</span>
         <br/>    
            <vs-button class="mr-6"  @click="ShowTamplate" v-if="MailTemplateID>0" >{{$t('ShoWHideTamplate')}}</vs-button>  
            <div v-if="show" style="padding-top:50px">
               <vs-input name="mailSubject" :disabled="true" :label-placeholder="$t('Subject')" v-model="MailModel.Subject" class="w-full mb-6" />
                      
                        <quill-editor :disabled="true" v-model="MailModel.Body" :options="editorOption" />
            </div>
            <vs-input :label="$t('Color')" id="colorPicer" class="vx-col w-full mt-1" type="color" name="favcolor"  v-model="ColorCode" />
      <vs-button class="ml-5 mt-4"  type="border" color="danger" @click="ShowStatusMailPreview=!ShowStatusMailPreview">{{ShowStatusMailPreview?'Hide':'Preview'}}</vs-button>
                      
  <vx-card v-if="ShowStatusMailPreview" class="mt-5">
               <p style="max-width: 70%;margin: auto;" v-html="MailModel.Body"></p>
            </vx-card>
      </div>

    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{$t('Submit')}}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('Cancel')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>

import vSelect from 'vue-select'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleStatus from "@/store/settings/status/moduleStatus.js";
import moduleMailTemplate from "@/store/settings/mailTemplate/moduleMailTemplate.js";
import {toolbar } from '@/gloabelConstant.js'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
    isSidebarActive(val) { 
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { ID, Name,ParentStatusID ,IsRegistration,MailTemplateID,ColorCode,Description} = JSON.parse( 
          JSON.stringify(this.data)
        );
        this.ID = ID;
        this.Name = Name;
        this.ParentStatusID = ParentStatusID;
        this.MailTemplateID =MailTemplateID;
        this.IsRegistration = IsRegistration;
        this.Description=Description;
      this.ColorCode =ColorCode;
       
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.ID, this.Name, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },

  data() {
    return {
      ShowStatusMailPreview:false,
      ID: null,
      Name: "",
      Description:"",
      ParentStatusID : null,
      MailTemplateID:null,
      IsRegistration : false,
      ColorCode:"#C0C0C0",
      show:false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      nextStatus:[],
      MailModel:{},
        editorOption: {
        modules: {
          toolbar: toolbar
        },
        placeholder: 'Message'
      },
    };
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
         
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.Name;
    },
    Statuses() {
      return this.$store.state.StatusList.Statuses;
    },
     MailTemplates() {
      return this.$store.state.MailTemplateList.MailTemplates;
    },
  },

  methods: {
    initValues() {
      debugger
      if (this.data.ID) return;
      this.ID = null;
      this.Name = "";
      this.ParentStatusID = null;
      this.MailTemplateID =null;
      this.IsRegistration = false;
      this.MailModel={};
       this.show =false;
       this.ColorCode = "#C0C0C0";
         this.nextStatus=[];
    },
    getMailData(){
      debugger;
        this.$store.dispatch("MailTemplateList/GetItemByID", this.MailTemplateID)
      .then(res => { 
        this.MailModel = res.data;
       })
      .catch(err => {
         debugger;
        if(err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err) })
    },
ShowTamplate() {
       if(this.show)
       this.show=false
       else
       this.show =true
    },
      getNextStatus(){
        this.nextStatus=[];
       this.$store.state.StatusList.Statuses.forEach(element => {
         if(element.IsRegistration==this.IsRegistration)
            this.nextStatus.push(element);
       });
      },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            ID: this.ID,
            Name: this.Name,
            ParentStatusID : this.ParentStatusID,
            MailTemplateID :this.MailTemplateID,
            IsRegistration : this.IsRegistration ,
            ColorCode : this.ColorCode,
            Description:this.Description
          };

          if (this.ID !== null && this.ID >= 0) {
            this.$store.dispatch("StatusList/updateItem", obj).catch(err => {
              console.error(err);
            });
          } else {
            delete obj.ID;
            obj.popularity = 0;
            this.$store.dispatch("StatusList/addItem", obj).catch(err => {
              console.error(err);
            });
          }

          this.$emit("closeSidebar");
          this.initValues();
          //this.$store.dispatch("foodTypeList/fetchfoodTypeListItems");
        }
      });
    },

   
  },
   created() {
    if (!moduleStatus.isRegistered) {
      this.$store.registerModule("StatusList", moduleStatus);
      moduleStatus.isRegistered = true;
    }
    this.$store.dispatch("StatusList/fetchDataListItems");

    if (!moduleMailTemplate.isRegistered) {
      this.$store.registerModule("MailTemplateList", moduleMailTemplate);
      moduleMailTemplate.isRegistered = true;
    }
    this.$store.dispatch("MailTemplateList/fetchDataListItems");
    this.getNextStatus();
  },
  components: {
    quillEditor,
    VuePerfectScrollbar,
    vSelect 
  }
};
</script>
<style lang="scss" >
input[type="color" i]{
    height: 35px!important;
  }
  #colorPicer .vs-input--input.normal
  {
  padding: 0.2rem
  }
</style>
<style lang="scss" scoped>
 
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
 
</style>
